import React from 'react'
import {
  Card,
  CardBody,
  Row,
  Col,
  CardTitle
} from 'reactstrap'


const Card_p = ({ titulo, valor, icone, cor, imagem, porcentagem, click, clicou, setClicou, altura }) => {

  return (
    <Col 
      lg="3" 
      md="6" 
      sm="6" 
      style={{ cursor: 'pointer' }} 
      onClick={() => {setClicou(true); click(titulo)}}
      onMouseEnter = {()=>{if(clicou === false){click(titulo)}}}
      className="mt-auto"
    >
      <Card className={"card-stats border "+altura+" text-center"}>
        <CardBody className="card-valores">
          <Row className="justify-content-md-center">
          <Col md="12" className="p-0">
              <div className="numbers card-valor text-center border-bottom pb-1">
                <h5 className="card-category mb-0">{titulo}</h5>
                {/* <CardTitle className="m-0"><Monetario valor={valor} Vendas /></CardTitle> */}
              </div>
            </Col>

            <Col md="4" className="px-2">
              <div className="icon-big text-center icon-warning">
                <img src={imagem} className="mt-auto mb-auto" alt=""/>
              </div>
            </Col>
            
            <Col md="8" className="">
              <div className="numbers card-valor">
                <p className=""><b>{valor}</b></p>
                <h5 className="">{porcentagem}</h5>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

const Card_g = ({ titulo, valor, icone, cor, imagem, porcentagem, click, clicou, setClicou}) => {
  return (
    <Col 
      lg="6" 
      md="8" 
      sm="8" 
      style={{ cursor: 'pointer' }} 
      onClick={() => {setClicou(true); click(titulo)}}
      onMouseEnter = {()=>{if(clicou === false){click(titulo)}}}
    >
      <Card className="card-stats border py-4">
        <CardBody className="card-valores">
          <Row>
            <Col md="3" className="py-2 px-0">
              <div className="icon-big text-center icon-warning">
                <img src={imagem} className="img-fluid" alt=""/>
              </div>
            </Col>
            <Col md="5" className="mt-auto mb-auto p-0">
              <div className="icon-big text-center icon-warning">
                {porcentagem}
              </div>
            </Col>
            <Col md="4" className="mt-auto mb-auto p-0">
              <div className="numbers card-valor text-center pt-0">
                <h5 className="card-category border-bottom pb-1 mb-0">{titulo}</h5>
                {/* <CardTitle className="m-0"><Monetario valor={valor} Vendas /></CardTitle> */}
                <CardTitle className="m-0 pt-1"><b>{valor}</b></CardTitle>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export {Card_p, Card_g}
